import { Text, TextLinkStyles } from "@origin-digital/ods-core";
import React, { MouseEvent } from "react";
import { chatMessengerShow, navTo } from "@origin-digital/event-dispatcher";
import { ProfileFieldMapTypes } from "src/crm/profileFieldMapContextHelpers";
import { ContactPreferenceRefetchFieldFunction } from "../../../crm/profileFieldMap";

export enum ContactOptionType {
  EMAIL = "EMAIL",
  POST = "POST",
}

type ContactOptionTypeLabel = {
  [key in ContactOptionType]: string;
};

export const ContactOptionTypeLabelMap: ContactOptionTypeLabel = {
  [ContactOptionType.EMAIL]: "email address",
  [ContactOptionType.POST]: "postal address",
};

/**
 * Prompt users when we don't have a value for that contact option
 * This is only configured for the LPG tile as Kraken data is always expected
 */
const ChatCTA = ({
  contactType,
  profileType,
}: Pick<ContactOptionRecipient, "profileType" | "contactType">) => {
  const handleMessageUsClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    chatMessengerShow({});
  };

  return (
    <Text variant="body-small" tone="neutralLight">
      There is no {ContactOptionTypeLabelMap[contactType]} for this account.
      Please{" "}
      <TextLinkStyles
        as="button"
        data-id={`update-contact-details-${profileType?.toLowerCase()}`}
        onClick={handleMessageUsClick}
      >
        message us
      </TextLinkStyles>{" "}
      to update
    </Text>
  );
};

type ContactOptionRecipient = {
  recipientValue?: string | null;
  showPromptChat: boolean;
  contactType: ContactOptionType;
  profileType: ProfileFieldMapTypes;
  refetch: ContactPreferenceRefetchFieldFunction;
};

export const ContactOptionRecipient = ({
  recipientValue,
  showPromptChat,
  contactType,
  profileType,
  refetch,
}: ContactOptionRecipient) => {
  const navToUpdateScreen = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (contactType === ContactOptionType.EMAIL) {
      await navTo.profileEmail();
    } else if (contactType === ContactOptionType.POST) {
      await navTo.profileAddress();
    }
    refetch(profileType);
  };

  return (
    <>
      {recipientValue && (
        <Text variant="body-small" tone="neutralLight">
          <Text inline data-id="contact-value">
            {recipientValue}
          </Text>{" "}
          (
          <TextLinkStyles
            as="button"
            data-id="update-contact-details-link"
            onClick={navToUpdateScreen}
          >
            Update
          </TextLinkStyles>
          )
        </Text>
      )}
      {showPromptChat && (
        <ChatCTA contactType={contactType} profileType={profileType} />
      )}
    </>
  );
};
